import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import Stack from "@mui/material/Stack";
import { styled } from "@mui/material/styles";
import { Button } from "../Button";

export const Root = styled(Stack)(({ theme }) =>
    theme.unstable_sx({
        gap: 5,
    }),
);

export const PersonalChangeButton = styled(Button)(({ theme }) =>
    theme.unstable_sx({
        color: "primary.main",
        textTransform: "none",
    }),
);

export const ChangeDialog = styled(Dialog)(({ theme }) =>
    theme.unstable_sx({
        "& .MuiDialog-paper": {
            width: { md: 480 },
            maxWidth: "100%",
            m: 0,
        },
    }),
);

export const ChangeDialogContent = styled(DialogContent)(({ theme }) =>
    theme.unstable_sx({
        display: "flex",
        flexDirection: "column",
        gap: 5,
        py: 7,
        px: 4,
    }),
);

export const ChangeDialogCloseButton = styled(Button)(({ theme }) =>
    theme.unstable_sx({
        alignSelf: "flex-end",
    }),
);
